(function () {
  'use strict';

  angular
    .module('settings.customization')
    .controller('settingsCustomizationCtrl', settingsCustomizationCtrl);

  settingsCustomizationCtrl.$inject = [
    'Customization',
    '$filter',
    '$stateParams',
    '$rootScope',
    '$mdDialog',
  ];

  function settingsCustomizationCtrl(
    Customization,
    $filter,
    $stateParams,
    $rootScope,
    /** @type {angular.material.IDialogService} */ $mdDialog,
  ) {
    var vm = this;

    vm.unitStatusTypes = unitStatusTypes();
    vm.unitStatusList = [];
    vm.unitStatus = { type: 1 };
    vm.getUnitStatusIcon = getUnitStatusIcon;
    vm.onUnitStatusCreate = onUnitStatusCreate;
    vm.onUnitStatusUpdate = onUnitStatusUpdate;
    vm.onUnitStatusDelete = onUnitStatusDelete;

    vm.leadStatusList = [];
    vm.leadStatus = {};
    vm.onLeadStatusCreate = onLeadStatusCreate;
    vm.onSeparatorCreate = onSeparatorCreate;
    vm.onLeadStatusUpdate = onLeadStatusUpdate;
    vm.onLeadStatusDelete = onLeadStatusDelete;
    vm.onUpdateOrderLeadStatus = onUpdateOrderLeadStatus;

    vm.priceList = [];
    vm.price = {};
    vm.onPriceCreate = onPriceCreate;
    vm.onPriceUpdate = onPriceUpdate;
    vm.onPriceDelete = onPriceDelete;
    vm.getPriceById = getPriceById;

    vm.company = {};
    vm.timezone = '';
    vm.currencyList = [];
    vm.timeListList = [];
    vm.plotMeasureList = [];
    vm.getTimezoneByName = getTimezoneByName;
    vm.onCompanyUpdate = onCompanyUpdate;
    vm.showModalRemoveUnitStatus = showModalRemoveUnitStatus;
    vm.showModalRemoveLeadStatus = showModalRemoveLeadStatus;
    vm.ModalRemoveUnitStatusDialogController =
      ModalRemoveUnitStatusDialogController;
    vm.ModalRemoveLeadStatusDialogController =
      ModalRemoveLeadStatusDialogController;
    vm.init = init();
    vm.cu = '';

    function init() {
      getUnitStatusList();
      getLeadStatusList();
      getPriceList();
      getCompany();
      getCurrencyList();
      getTimezoneList();
      getPlotMeasureList();
    }

    function showModalRemoveLeadStatus() {
      $mdDialog.show({
        clickOutsideToClose: true,
        template: require('../settings.customization/remove.lead.status.popup.html'),
        controller: vm.ModalRemoveLeadStatusDialogController,
      });
    }

    ModalRemoveLeadStatusDialogController.$inject = ['$scope', '$mdDialog'];
    function ModalRemoveLeadStatusDialogController(
      $scope,
      /** @type {angular.material.IDialogService} */ $mdDialog,
    ) {
      $scope.showForm = function () {
        var useUnitStatus = JSON.parse(localStorage.getItem('useUnitStatus'));
        var result;
        if (useUnitStatus.count != 0) {
          result = true;
        } else {
          result = false;
        }
        return result;
      };
      $scope.closeDialog = function () {
        $mdDialog.hide();
      };
      $scope.okAction = function () {
        updateLeadsStatus();
        $mdDialog.hide();
      };
    }

    function updateLeadsStatus() {
      var newStatusId = localStorage.getItem('newStatus');
      var useUnitsStatus = localStorage.getItem('useUnitStatus');
      var oldStatusId = localStorage.getItem('deletedStatus');
      $.ajax({
        type: 'POST',
        url: 'api/customization/update_deleted_leads_status',
        data:
          'upd=' +
          useUnitsStatus +
          '&new=' +
          newStatusId +
          '&old=' +
          oldStatusId,
        success: function (response) {
          deleteLeadsStatus();
        },
      });
    }

    function deleteLeadsStatus() {
      var deletedStatus = JSON.parse(localStorage.getItem('deletedStatus'));
      var params = {
        custom_type: 'lead_status',
        id: deletedStatus.id,
      };

      Customization.delete(params, deletedStatus, function (response) {
        vm.leadStatusList.forEach(function (item, index) {
          if (item.id == deletedStatus.id) {
            vm.leadStatusList.splice(index, 1);
          }
        });
      });
    }

    function showModalRemoveUnitStatus() {
      $mdDialog.show({
        clickOutsideToClose: true,
        template: require('../settings.customization/remove.unit.status.popup.html'),
        controller: vm.ModalRemoveUnitStatusDialogController,
      });
    }

    ModalRemoveUnitStatusDialogController.$inject = ['$scope', '$mdDialog'];
    function ModalRemoveUnitStatusDialogController(
      $scope,
      /** @type {angular.material.IDialogService} */ $mdDialog,
    ) {
      $scope.showForm = function () {
        var useUnitStatus = JSON.parse(localStorage.getItem('useUnitStatus'));
        var result;
        if (useUnitStatus.count != 0) {
          result = true;
        } else {
          result = false;
        }
        return result;
      };
      $scope.closeDialog = function () {
        $mdDialog.hide();
      };
      $scope.okAction = function () {
        updateUnitsStatus();
        $mdDialog.hide();
      };
    }

    function updateUnitsStatus() {
      var newStatusId = localStorage.getItem('newStatus');
      var useUnitsStatus = localStorage.getItem('useUnitStatus');
      var oldStatusId = localStorage.getItem('deletedStatus');
      $.ajax({
        type: 'POST',
        url: 'api/customization/update_deleted_units_status',
        data:
          'upd=' +
          useUnitsStatus +
          '&new=' +
          newStatusId +
          '&old=' +
          oldStatusId,
        success: function (response) {
          deleteUnitsStatus();
        },
      });
    }

    function deleteUnitsStatus() {
      var deletedStatus = JSON.parse(localStorage.getItem('deletedStatus'));
      var params = {
        custom_type: 'unit_status',
        id: deletedStatus.id,
      };

      Customization.delete(params, deletedStatus, function (response) {
        vm.unitStatusList.forEach(function (item, index) {
          if (item.id == deletedStatus.id) {
            vm.unitStatusList.splice(index, 1);
          }
        });
      });
    }

    function onUnitStatusDelete(object) {
      localStorage.setItem('deletedStatus', JSON.stringify(object));
      $.ajax({
        type: 'GET',
        url: 'api/customization/get_use_units_status/' + object.id,
        async: true,
        success: function (response) {
          localStorage.setItem('useUnitStatus', JSON.stringify(response));
          vm.showModalRemoveUnitStatus();
        },
      });
    }

    function onUnitStatusCreate() {
      var params = {
        custom_type: 'unit_status',
      };

      Customization.create(params, vm.unitStatus, function (response) {
        vm.unitStatusList.push(response);
        vm.unitStatus = { type: 1 };
      });
    }

    function onUnitStatusUpdate(object) {
      var params = {
        custom_type: 'unit_status',
        id: object.id,
      };

      Customization.update(params, object, function (response) {
        vm.unitStatusList.forEach(function (unitStatus) {
          if (unitStatus.id == response.id) {
            unitStatus.name = response.name;
          }
        });
      });
    }

    function unitStatusTypes() {
      return [
        {
          id: 1,
          name: 'Not in stock',
        },
        {
          id: 2,
          name: 'Free, in stock',
        },
        {
          id: 3,
          name: 'Booked',
        },
        {
          id: 4,
          name: 'Sold',
        },
      ];
    }

    function getUnitStatusIcon(type) {
      var icons = {
        1: '-color_closed',
        2: '-color_free',
        3: '-color_reserved',
        4: '-color_sold',
      };
      return icons[type];
    }

    function getUnitStatusList() {
      Customization.getUnitStatusList(function (response) {
        vm.unitStatusList = response;
        localStorage.setItem('unitStatusList', JSON.stringify(response));
      });
    }

    function onLeadStatusCreate() {
      var params = {
        custom_type: 'lead_status',
      };

      Customization.create(params, vm.leadStatus, function (response) {
        vm.leadStatusList.push(response);
        vm.leadStatus = {};
      });
    }

    function onSeparatorCreate() {
      vm.leadStatus = {
        name: '-------',
      };
      onLeadStatusCreate();
      vm.leadStatus = {};
    }

    function onLeadStatusUpdate(object) {
      var params = {
        custom_type: 'lead_status',
        id: object.id,
      };

      Customization.update(params, object, function (response) {
        vm.leadStatusList.forEach(function (leadStatus) {
          if (leadStatus.id == response.id) {
            leadStatus.name = response.name;
          }
        });
      });
    }

    function onLeadStatusDelete(object) {
      localStorage.setItem('deletedStatus', JSON.stringify(object));
      $.ajax({
        type: 'GET',
        url: 'api/customization/get_use_leads_status/' + object.id,
        async: true,
        success: function (response) {
          localStorage.setItem('useUnitStatus', JSON.stringify(response));
          vm.showModalRemoveLeadStatus();
        },
      });
    }

    function getLeadStatusList() {
      Customization.getLeadStatusList(function (response) {
        vm.leadStatusList = response;
        localStorage.setItem('leadStatusList', JSON.stringify(response));
      });
    }

    function getPriceList() {
      Customization.getPriceList(function (response) {
        vm.priceList = response;
        vm.price.parent_id = vm.priceList[0].id;
      });
    }

    function onPriceCreate() {
      var params = {
        custom_type: 'price',
      };

      Customization.create(params, vm.price, function (response) {
        vm.priceList.push(response);
        vm.price = {
          parent_id: vm.priceList[0].id,
        };
      });
    }

    function onPriceUpdate(object) {
      var params = {
        custom_type: 'price',
        id: object.id,
      };

      Customization.update(params, object, function (response) {});
    }

    function onPriceDelete(object) {
      var params = {
        custom_type: 'price',
        id: object.id,
      };

      Customization.delete(params, object, function (response) {
        vm.priceList.splice(vm.priceList.indexOf(object), 1);
      });
    }

    function getPriceById(id) {
      var prices = $filter('filter')(vm.priceList, { id: id }, true);

      return prices.pop();
    }

    function getCurrencyList() {
      Customization.getCurrencyList(function (response) {
        vm.currencyList = response;
      });
    }

    function getTimezoneList() {
      Customization.getTimezoneList(function (response) {
        vm.timezoneList = response;
        vm.getTimezoneByName(vm.company.timezone);
      });
    }

    function getPlotMeasureList() {
      Customization.getPlotMeasureList(function (response) {
        vm.plotMeasureList = response;
      });
    }

    function getCompany() {
      Customization.getCompany(function (response) {
        vm.company = response;
      });
    }

    function onCompanyUpdate() {
      vm.company.timezone = vm.timezoneList[vm.timezone];

      Customization.updateCompany({}, vm.company, function (response) {});
    }

    function getTimezoneByName(name) {
      angular.forEach(vm.timezoneList, function (value, key) {
        if (value == name) {
          vm.timezone = key;
        }
      });
    }

    function onUpdateOrderLeadStatus() {
      var data = { token: vm.token, order: [] };
      vm.leadStatusList.forEach(function (item) {
        data.order.push(item.id);
      });
      Customization.updateLeadStatusOrder(data, function (response) {
        getLeadStatusList();
      });
    }
  }
})();
